// extracted by mini-css-extract-plugin
export default {"listItem":"burger-constructor-element_listItem__fR2cv","dragIcon":"burger-constructor-element_dragIcon__4dTPK"};